/// <reference types="vite/types/importMeta.d.ts" />
// mixpanelInit.ts
import mixpanel from "mixpanel-browser";

function readMeta(name: string): string | undefined {
  const el = document.querySelector(`meta[name="${name}"]`);
  return el?.getAttribute("content") || undefined;
}

export function initMixpanelFromMeta() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const token = readMeta("mixpanel-token");
  if (!token) return;

  mixpanel.init(token, {
    debug: !!import.meta.env?.DEV,
    track_pageview: true,
    record_mask_text_selector: ""
  });

  const userId = readMeta("mixpanel-user-id");
  if (userId) {
    // Set the distinct_id and register a convenient prop
    mixpanel.identify(String(userId));
    mixpanel.register({ user_id: String(userId) });
  }
}